import React from "react"
// import Nav from "./nav"
import Navbar from "./Navbar/Navbar"

const Header = () => (
  <header>
    <h1>Przewodnik po Wrocławiu</h1>
    <Navbar />
  </header>
)

export default Header
